import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { LanguageLoader } from '../../assets/languages';
import Modal from './Modal';
import FieldContainer from './FieldContainer';
import { Toastify } from '../utils';
import { CheckPostalCode } from '../utils/validation';
import Tree from './Tree';
import { GetEntryAPI } from '../../services';

const Addresses = ({defaultValue, onChange}) =>
{
	const preferences = useSelector((state) => state.preferences);
	const settings = useSelector((state) => state.settings);
	const language = LanguageLoader(preferences.language);
	const defaultPopup = {id:'', name:'', country:'', state:'', city:'', geographical_area_id:'', postalcode:'', street:'', latitude:'', longitude:'', billing:false, shipping:false};
	const [popupData, SetPopupData] = useState(defaultPopup);
	const [data, SetData] = useState([]);
	const [firstLoad, SetFirstLoad] = useState(true);
	const [editing, SetEditing] = useState('');
	const [geographicalAreas, SetGeographicalAreas] = useState([]);
	const handler = useRef(null);

	useEffect(() =>
	{
		if(defaultValue && defaultValue.length && firstLoad)
		{
			SetData(defaultValue);
			SetFirstLoad(false);
		}
	// eslint-disable-next-line
	}, [defaultValue]);

	useEffect(() =>
	{
		if(onChange)
		{
			onChange(data);
		}
		GetGeographicalAreas();
	// eslint-disable-next-line
	}, [data]);

	const HandleSubmit = () =>
	{
		if(!settings.multiple_address && data.filter((address) => address.street.length || address.city.length).length)
		{
			if(editing !== '' && (data[editing].billing !== popupData.billing || data[editing].shipping !== popupData.shipping))
			{
				for(const address of data)
				{
					if(popupData.billing && address.billing)
					{
						Toastify(language.ERROR.DUPLICATE_BILLING_ADDRESS);
						return false;
					}
					else if(popupData.shipping && address.shipping)
					{
						Toastify(language.ERROR.DUPLICATE_SHIPPING_ADDRESS);
						return false;
					}
				}
			}
		}
		if(popupData.postalcode.length && !CheckPostalCode(popupData.postalcode)) 
		{
			Toastify(language.ERROR.WRONG_POSTAL_CODE);
			return false;
		}
		
		if(popupData.postalcode.length && !CheckPostalCode(popupData.postalcode)) 
		{
			Toastify(language.ERROR.WRONG_POSTAL_CODE);
			return false;
		}
		if(!popupData.postalcode && !popupData.street && !popupData.geographical_area_id)
		{
			Toastify(language.ERROR.WRONG_DATA);
			return false;
		}
		if(editing !== '')
		{
			let tempData = [...data];
			tempData[editing] = popupData;
			SetData(tempData);
		}
		else
		{
			SetData(data => [...data, popupData]);
		}
		SetPopupData(defaultPopup);
		SetEditing('');
		return true;
	}

	const HandleDelete = (key) =>
	{
		const newData = [...data];
		newData.splice(key, 1);
		SetData(newData);
	}

	const TypeSwitcher = (checked) =>
	{
		if(checked)
		{
			SetPopupData({...popupData, billing:false, shipping:true});
		}
		else
		{
			SetPopupData({...popupData, billing:true, shipping:false});
		}
	}

	const GetGeographicalAreas = async () =>
	{
		const data = {module:'Geographical_Areas', mode:'hierarchy'}
		const APIResponse = await GetEntryAPI(data);
		if(APIResponse)
		{
			SetGeographicalAreas(APIResponse);
		}
	}

	const GetGeographicalParents = async (recordID) =>
	{
		const data = {module:'Geographical_Areas', mode:'hierarchy', id:recordID}
		const APIResponse = await GetEntryAPI(data);
		if(APIResponse)
		{
			SetPopupData({...popupData,
				geographical_area_id: recordID,
				country: APIResponse.country,
				state: APIResponse.state,
				city: APIResponse.city,
			});
		}
	}
	
	return <div className='mt-1 relative'>
		{data.filter((address) => address.street.length || address.city.length).map((address, index) =>
			// This part is just for determine this address is isBranchor not (when isBranchis 1)
			<div key={index} className={'flex w-full mb-5 ' + ((address.isBranch=== 1 || address.module === 'Branches') ? 'bg-amber-50 border border-amber-200 rounded' : '')}>
				<div className='me-3 cursor-pointer w-8'>
					<i className='py-4 px-2 fa fa-trash-alt fa-lg text-danger rounded-md' onClick={()=>HandleDelete(index)}></i>
				</div>
				<div className='grow flex justify-between overflow-hidden items-center'>
					<span className='inline-block w-[70%] overflow-x-scroll text-ellipsis lg:whitespace-nowrap text-sm' title={[address.state, address.city, address.street].join(', ')} style={{scrollbarWidth: 'none'}}>{[address.state, address.city, address.street].join(', ')}</span>
					<span>
						{address.billing ? <span className='bg-info text-white px-1 py-1 rounded text-xs mx-1'>{language.FIELDS.BILLING}</span> : null}
						{address.shipping ? <span className='bg-info text-white px-1 py-1 rounded text-xs mx-1'>{language.FIELDS.SHIPPING}</span> : null}
						{(address.isBranch=== 1 || address.module === 'Branches') ? <span className='bg-amber-500 text-white px-1 py-1 rounded text-xs mx-1'>شعبه</span> : null}
					</span>
				</div>
				<div className='mx-2 flex gap-3 items-center'>
					<i className='fa fa-map-marker-alt cursor-pointer p-1 text-primary'></i>
					<i className='fa fa-pencil mx-1 cursor-pointer' onClick={() => {handler.current?.click(); SetPopupData(address); SetEditing(index);}}></i>
				</div>
			</div>
		)}
		<Modal handler={<i className={"py-4 px-2 fa fa-plus fa-lg bg-primary text-white rounded-md"+((settings.multiple_address || (!settings.multiple_address && data.filter((address) => address.street.length || address.city.length).length < 2)) ? '' : ' !hidden')} ref={handler} onClick={() => {if(!settings.multiple_address){ SetPopupData({...popupData, billing: true});}}}></i>} onSubmit={HandleSubmit} onClose={() => SetPopupData(defaultPopup)}>
			<div className='flex flex-wrap'>
				{settings.multiple_address ? <FieldContainer className="me-10" label={language.FIELDS.TITLE}><input type="text" className="form-control" defaultValue={popupData.name} onChange={(e) => SetPopupData({...popupData, name: e.target.value})}/></FieldContainer> : null}
				<FieldContainer label={language.FIELDS.GEOGRAPHICAL} className={'relative'}>
					<Tree vardef={{options: geographicalAreas}} onChange={(value) => GetGeographicalParents(value)} defaultValue={popupData.geographical_area_id}/>
					<span className='absolute end-11 pt-3 z-0 top-6 text-tertiaryFont'>
						{popupData.country ? <><span>{popupData.country}</span><i className='fa fa-left-long mx-1 text-xs'></i></> : null}
						{popupData.state ? <><span>{popupData.state}</span><i className='fa fa-left-long mx-1 text-xs'></i></> : null}
						<span>{popupData.city}</span>
					</span>
				</FieldContainer>
				<FieldContainer label={language.FIELDS.POSTAL_CODE}><input type="text" className="form-control" defaultValue={popupData.postalcode} onChange={(e) => SetPopupData({...popupData, postalcode: e.target.value})}/></FieldContainer>
				<FieldContainer label={language.FIELDS.ADDRESS}><input type="text" className="form-control" defaultValue={popupData.street} onChange={(e) => SetPopupData({...popupData, street: e.target.value})}/></FieldContainer>
				{settings.multiple_address ?
				<FieldContainer>
					<div className="flex justify-between mt-2">
						<div className="form-check form-switch items-center flex">
							<input className="form-check-input mt-3" type="checkbox" onChange={(e) => SetPopupData({...popupData, billing: e.target.checked})} defaultChecked={popupData.billing ? true : false}/>
							<label className="form-check-label mt-5 inline-block">{language.FIELDS.ADDRESS+' '+language.FIELDS.BILLING}</label>
						</div>
						<div className="form-check form-switch items-center flex">
							<input className="form-check-input mt-3" type="checkbox" onChange={(e) => SetPopupData({...popupData, shipping: e.target.checked})} defaultChecked={popupData.shipping ? true : false}/>
							<label className="form-check-label mt-5 inline-block">{language.FIELDS.ADDRESS+' '+language.FIELDS.SHIPPING}</label>
						</div>
						<div></div>
					</div>
				</FieldContainer>
				:
				<FieldContainer>
				<div className="flex justify-end items-center mt-6">
					<div className="form-check form-switch items-center flex">
						<label className="form-check-label mt-2 inline-block">{language.FIELDS.ADDRESS+' '+language.FIELDS.BILLING}</label>
						<input className="form-check-input switch mx-2" type="checkbox" onChange={(e) => TypeSwitcher(e.target.checked)} defaultChecked={popupData.shipping ? true : false}/>
						<label className="form-check-label mt-2 inline-block">{language.FIELDS.ADDRESS+' '+language.FIELDS.SHIPPING}</label>
					</div>
				</div>
				</FieldContainer>}
			</div>
		</Modal>
	</div>
};

export default Addresses;